module.exports = __webpack_public_path__ + "img/doc-and-ref.ccb03f55.svg";